<script setup lang="ts">
  import { ExternalRoute } from "@/constants/externalRoute.ts"
  import { type EnrolmentRoute } from "@/constants/routes/enrolment.ts"
  import { type MyAccountRoute } from "@/constants/routes/myAccount.ts"
  import { Button } from "@/components/ui/button"
  import { Link } from "@/components/ui/link"

  const props = defineProps<{
    to: MyAccountRoute | EnrolmentRoute | ExternalRoute
    label: string
  }>()
</script>

<template>
  <Button variant="text" as-child :data-testid="`${props.label}-nav-link`">
    <Link :to="props.to"> {{ props.label }} </Link>
  </Button>
</template>
